import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as MenuApi from '../api/menu'

export default function Menu() {

    const columns = [
        {
            title: "Imagem",
            field: '_id',
            filtering: false,
            sorting: false,
            cellStyle: {
                maxWidth: 66,
            },
            render: rowData =>
                <img
                    className="noticia-img"
                    src={rowData.publicImg}
                    alt="" />
        },

        {
            title: "Menu",
            field: "name",
            sorting: true
        },
        {
            title: "Menu secundário",
            field: "isSubmenu",
            sorting: true,
            render: rowData => rowData.isSubmenu ? 'Sim' : 'Não'
        },
    ];

    return (
        <React.Fragment>
            <Header title={"Menu"} subtitle={"Lista de menus"}>
                <i className="fas fa-coins awesome-header"></i>
            </Header>
            <Container className="page-content">
                <BigCard>
                    <Tabela
                        url={'menu'}
                        columns={columns}
                        fetchFunction={MenuApi.fetchItems}
                        removeFunction={MenuApi.removeItem}
                        statusFunction={MenuApi.statusItem}
                        enableSearch
                    />
                </BigCard>
            </Container>
        </React.Fragment>
    )
}